import React, { useContext } from "react";
import type { FC } from "react";

import { VibeContext } from "../../Vibe";
import { TITLE_SIZE_BY_VIBE_CONTEXT } from "../../constants/sizes";
import VibeTextCore from "../../helper/VibeTextCore";

import type { VibeTextCoreProps } from "../../helper/VibeTextCore";

const VIBE_TITLE_TEST_ID = "vibe-title-test-id";

export const VibeTitle: FC<VibeTextCoreProps> = (props) => {
    const { context } = useContext(VibeContext);

    const textProps: VibeTextCoreProps = (() => {
        if (context !== "custom") {
            return {
                ...props,
                size: TITLE_SIZE_BY_VIBE_CONTEXT[context],
            } as VibeTextCoreProps;
        }

        return props;
    })();

    return <VibeTextCore data-tsid={VIBE_TITLE_TEST_ID} {...textProps} />;
};

VibeTitle.displayName = "Vibe.Title";

export default VibeTitle;
